import React from 'react';
import { useForm, Controller } from 'react-hook-form';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import useTitle from 'hooks/useTitle';

import { InputText } from 'components/form';
import Button from 'components/button';
import PropTypes from 'prop-types';

import { useLoginMutation } from 'api/authAPI';

import { showAlert } from 'features/modal/modal';
import { useDispatch } from 'react-redux';
import { handleError } from 'utils';
import { useTranslation } from 'react-i18next';

const Login = ({ otpStepSubmit }) => {
	const dispatch = useDispatch();
	const { t } = useTranslation();

	const baseEnvDomain = process.env.REACT_APP_API_URL.split('/')[2];

	useTitle('Login');

	//
	const [login] = useLoginMutation();

	const schema = yup.object().shape({
		email: yup.string().email().required(t('this field is required')),
		password: yup.string().required(t('this field is required'))
	});

	const { control, handleSubmit } = useForm({
		resolver: yupResolver(schema),
		defaultValues: {
			email: '',
			password: ''
		}
	});

	const onSubmit = data => {
		login(data)
			.unwrap()
			.then(() => {
				otpStepSubmit(true);
			})
			.catch(err => {
				dispatch(
					showAlert({
						type: 'error',
						title: 'Error',
						content: handleError(err)
					})
				);
			});
	};
	return (
		<form onSubmit={handleSubmit(onSubmit)}>
			<Controller
				name='email'
				control={control}
				rules={{ required: true }}
				render={({ field: { onChange, onBlur, value, name }, fieldState: { invalid, error } }) => (
					<InputText
						className='mb-3'
						label={t('Email Address')}
						type='text'
						name={name}
						value={value}
						onChange={onChange} // send value to hook form
						onBlur={onBlur} // notify when input is touched
						invalid={invalid ? invalid : undefined}
						error={error}
					/>
				)}
			/>
			<Controller
				name='password'
				control={control}
				rules={{ required: true }}
				render={({ field: { onChange, onBlur, value, name }, fieldState: { invalid, error } }) => (
					<>
						<InputText
							className='mb-3'
							label={t('Password')}
							type='password'
							name={name}
							value={value}
							onChange={onChange} // send value to hook form
							onBlur={onBlur} // notify when input is touched
							invalid={invalid ? invalid : undefined}
							error={error}
						/>
					</>
				)}
			/>
			<a
				role='button'
				className='d-flex justify-content-end text-decoration-underline px-2'
				href={`https://${baseEnvDomain}/forgot-password`}
				target='_self'
				rel='noreferrer'
			>
				{t("Forgot password")}
			</a>
			<Button type='submit' className='btn btn-primary w-100 mt-4'>
				{t("Sign in")}
			</Button>
		</form>
	);
};
Login.propTypes = {
	otpStepSubmit: PropTypes.func
};

export default Login;
